/* ============================================================================
   mm-bis-relay.js  — [2026-06-25]
   Relais "Alerte mail" (retour en stock) pour le form natif Klaviyo.
   ENABLED_HANDLES = [] -> actif sur TOUS les produits.
   ROLLBACK : retirer la ligne <script ... mm-bis-relay.js> dans mm-head.liquid.
   ============================================================================ */
(function () {
  "use strict";

  // Liste vide [] = TOUS les produits. (Sinon : ["handle-1","handle-2"])
  var ENABLED_HANDLES = [];

  var STYLE_ID = "mm-bis-relay-style";
  var PROXY_CLASS = "mm-bis-proxy";

  function isEnabled() {
    if (!ENABLED_HANDLES.length) return true;
    var path = window.location.pathname;
    for (var i = 0; i < ENABLED_HANDLES.length; i++) {
      if (path.indexOf("/products/" + ENABLED_HANDLES[i]) !== -1) return true;
    }
    return false;
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      ".klaviyo-bis-trigger.mm-product-cta{display:none !important;}" +
      "#klaviyo-bis-button-container{position:absolute !important;width:1px !important;height:1px !important;" +
      "padding:0 !important;margin:0 !important;overflow:hidden !important;clip:rect(0 0 0 0) !important;" +
      "opacity:0 !important;pointer-events:none !important;}" +
      "." + PROXY_CLASS + "{font-weight:700;}" +
      ".mm-product-cta[onclick*=\"waxOpenBackInStockModal\"]{font-weight:700;margin-top:0 !important;}";
    var st = document.createElement("style");
    st.id = STYLE_ID;
    st.textContent = css;
    document.head.appendChild(st);
  }

  function openKlaviyo() {
    var sel = "#klaviyo-bis-button-container button";
    var btn = document.querySelector(sel);
    if (btn) { btn.click(); return; }
    var tries = 0;
    var iv = setInterval(function () {
      var b = document.querySelector(sel);
      if (b) { clearInterval(iv); b.click(); }
      else if (++tries > 60) { clearInterval(iv); } // ~6s max
    }, 100);
  }

  function labelFor(scope) {
    var legacy = scope.querySelector(".klaviyo-bis-trigger");
    if (legacy && legacy.childNodes.length) {
      var t = (legacy.childNodes[0].textContent || "").trim();
      if (t) return t;
    }
    return "CRÉER UNE ALERTE MAIL";
  }

  function ensureProxy(scope) {
    var wax = scope.querySelector('[onclick*="waxOpenBackInStockModal"]');
    if (!wax) return;
    if (scope.querySelector("." + PROXY_CLASS)) return;
    var proxy = document.createElement("button");
    proxy.type = "button";
    proxy.className = PROXY_CLASS + " mm-product-cta mm-flex mm-w-full mm-align-center mm-justify-center mm-cursor-pointer";
    proxy.style.border = "0";
    proxy.textContent = labelFor(scope);
    proxy.addEventListener("click", openKlaviyo);
    wax.parentNode.insertBefore(proxy, wax);
  }

  function scan() {
    if (!isEnabled()) return;
    var ctas = document.querySelectorAll(".mm-product-form-component-cta");
    for (var i = 0; i < ctas.length; i++) ensureProxy(ctas[i]);
  }

  function init() {
    if (!isEnabled()) return;
    injectStyle();
    scan();
    var root = document.getElementById("MainContent") || document.body;
    try {
      new MutationObserver(scan).observe(root, { childList: true, subtree: true });
    } catch (e) {}
    setInterval(scan, 400); // filet de securite : re-cree le bouton s'il manque
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();